import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  RightDrawerContainer,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  PageHeader,
  Collapse,
  Select,
} from "antd";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import warning from "../../../Assets/Icons/warning.png";
import {
  ModalPopup,
  SuccessResetPassword,
} from "../../../Components/Modal/modal";
import {
  useSearchParams,
  useLocation,
  Link,
  useNavigate,
} from "react-router-dom";
import { resetUserPassword } from "../../../Services/loginServices";
import { usePasswordValidation } from "../../../hooks/usePasswordValidation";

import correctIcon from "../../../Assets/Icons/correct.svg";
import wrongIcon from "../../../Assets/Icons/wrong.svg";
import {
  getUserData,
  deleteUserAccount,
} from "../../../Services/loginServices";

const validateMessages = {
  required: "This field is required!",
  types: {
    email: "Email is not a valid email!",
  },
};

const UserProfileData = (props) => {
  const [SideDrawer, setSideDrawer] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const location = useLocation();
  let [searchParams] = useSearchParams();
  const [userData, setUserData] = useState();
  const email = searchParams.get("email");
  const [userDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const navigate = useNavigate();
  const notificationData = [
    {
      id: 1,
      name: "Orders",
      text: "User access to order management can be controlled here",
      options: [
        {
          name: "Requests",
          options: ["Order Approval Request"],
        },
        {
          name: "Confirmations",
          options: [
            "Order Approval Confirmation",
            "Order Rejection Alert",
            "Priority Flag Notification",
          ],
        },
      ],
    },
    {
      id: 2,
      name: "Job Cards",
      text: "User access to job card management can be controlled here",
      options: [
        {
          name: "Requests",
          options: ["Job Card Approval Request"],
        },
        {
          name: "Confirmations",
          options: [
            "Job Card Approval Confirmation",
            "Job Card Completion Confirmation",
            "Job Card Resubmitted for Approval",
          ],
        },
        {
          name: "Rejections",
          options: ["Job Card Rejection Alert", "Job Card Cancellation Alert"],
        },
      ],
    },
    // {
    //   id: 3,
    //   name: "Warehouse",
    //   text: "User access to warehouse operations can be controlled here",
    //   options: [
    //     {
    //       name: "Alerts",
    //       options: [
    //         "Stock Allocation Failure",
    //         "Stock Threshold Alert",
    //         "Location Capacity Breach",
    //       ],
    //     },
    //     {
    //       name: "Confirmations",
    //       options: ["Stock Movement Confirmation"],
    //     },
    //     {
    //       name: "Requests",
    //       options: ["Addition/Deletion of Warehouse Location"],
    //     },
    //   ],
    // },
    {
      id: 4,
      name: "System",
      text: "System-level notifications can be controlled here",
      options: [
        {
          name: "Alerts",
          options: [
            "Error during Save/Submission",
            "Failure of Fetch Orders",
            "Machine Inactive",
          ],
        },
        {
          name: "Confirmations",
          options: ["Bulk Upload of Orders Confirmation"],
        },
      ],
    },
  ];

  // email and password to post the changes
  const [password, setPassword] = useState({
    firstPassword: "",
    secondPassword: "",
  });
  const setFirst = (event) => {
    setPassword({ ...password, firstPassword: event.target.value });
  };
  const setSecond = (event) => {
    setPassword({ ...password, secondPassword: event.target.value });
  };
  const onConfirmClick = async () => {
    try {
      const resetResponse = await resetUserPassword(
        email,
        password.firstPassword
      );
      if (!resetResponse.error) {
        console.log("Response reset", resetResponse.msg);
        onClose();
      }
      // SuccessResetPassword()
    } catch (error) {
      console.log("Error Message:", error.response.data);
    } finally {
      setPassword({ ...password, firstPassword: "" });
    }
  };

  // Password validation - displaying
  const [validLength, hasNumber, upperCase, lowerCase, match, specialChar] =
    usePasswordValidation({
      firstPassword: password.firstPassword,
      secondPassword: password.secondPassword,
    });

  const fetchUserData = async () => {
    try {
      let getUser = await getUserData(email);
      console.log("User Details", getUser.data);
      const notification_config = getUser.data.notification_config;
      getUser = {
        ...getUser.data,
        notification_config: {
          job_card_approval_confirmation_email:
            notification_config?.jobcard.confirmations?.jobcard_approval?.email,
          job_card_approval_confirmation_in_app:
            notification_config?.jobcard.confirmations?.jobcard_approval?.in_app,
          job_card_completion_confirmation_email:
            notification_config?.jobcard?.confirmations?.jobcard_completion?.email,
          job_card_completion_confirmation_in_app:
            notification_config?.jobcard?.confirmations?.jobcard_completion?.in_app,
          job_card_resubmitted_for_approval_email:
            notification_config?.jobcard?.confirmations?.jobcard_resubmitted?.email,
          job_card_resubmitted_for_approval_in_app:
            notification_config?.jobcard?.confirmations?.jobcard_resubmitted.in_app,
          job_card_cancellation_alert_email:
            notification_config?.jobcard?.rejections?.jobcard_cancellation_alert?.email,
          job_card_cancellation_alert_in_app:
            notification_config?.jobcard?.rejections?.jobcard_cancellation_alert?.in_app,
          job_card_rejection_alert_email:
            notification_config?.jobcard?.rejections?.jobcard_rejection_alert?.email,
          job_card_rejection_alert_in_app:
            notification_config?.jobcard?.rejections?.jobcard_rejection_alert?.in_app,
          job_card_approval_request_email:
            notification_config?.jobcard?.requests?.jobcard_approval?.email,
          job_card_approval_request_in_app:
            notification_config?.jobcard?.requests?.jobcard_approval?.in_app,
          order_approval_confirmation_email:
            notification_config?.orders?.confirmations?.order_approval?.email,
          order_approval_confirmation_in_app:
            notification_config?.orders?.confirmations?.order_approval.in_app,
          order_rejection_alert_email:
            notification_config?.orders?.confirmations?.order_rejection_alert?.email,
          order_rejection_alert_in_app:
            notification_config?.orders?.confirmations?.order_rejection_alert?.in_app,
          priority_flag_notification_email:
            notification_config?.orders?.confirmations?.priority_flag_notification?.email,
          priority_flag_notification_in_app:
            notification_config?.orders?.confirmations?.priority_flag_notification?.in_app,
          order_approval_request_email:
            notification_config?.orders?.requests?.order_approval?.email,
          order_approval_request_in_app:
            notification_config?.orders?.requests?.order_approval?.in_app,
          "error_during_save/submission_email":
            notification_config?.system?.alerts?.error_during_save?.email,
          "error_during_save/submission_in_app":
            notification_config?.system?.alerts?.error_during_save?.in_app,
          failure_of_fetch_orders_email:
            notification_config?.system?.alerts?.fetch_orders_failure?.email,
          failure_of_fetch_orders_in_app:
            notification_config?.system?.alerts?.fetch_orders_failure?.in_app,
          machine_inactive_email:
            notification_config?.system?.alerts?.inactive_machine?.email,
          machine_inactive_in_app:
            notification_config?.system?.alerts?.inactive_machine?.in_app,
          bulk_upload_of_orders_confirmation_email:
            notification_config?.system?.confirmations?.bulk_action?.email,
          bulk_upload_of_orders_confirmation_in_app:
            notification_config?.system?.confirmations?.bulk_action?.in_app,
        },
      };
      setUserData(getUser);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const showAccessIcon = (props = false) => {
    return props ? (
      <Iconmoon icon="correct" size={16} color="#3FBD61" />
    ) : (
      <Iconmoon icon="wrong" size={16} color="#EA4E2C" />
    );
  };

  const modalShow = () => {
    setIsVisibleModal(true);
  };

  const modalClose = () => {
    setIsVisibleModal(false);
  };

  const modalConfirm = async (id) => {
    try {
      const deleteResponse = await deleteUserAccount(id);
      // navigate("/organization-setting/user-management/");
      setTimeout(() => {
        navigate("/organization-setting/user-management", {
          state: { response: deleteResponse },
        });
      }, 10);
    } catch (error) {
      console.log(error.response);
    } finally {
      setIsVisibleModal(false);
    }
  };

  const showDrawer = () => {
    setSideDrawer(true);
  };

  const onClose = () => {
    setSideDrawer(false);
  };

  const canResetPassword = (editor, account) => {
    console.log(editor, account);
    if (editor == "SUPER_ADMIN") {
      if (account == "SUPER_ADMIN") return false;
      else return true;
    } else if (editor == "ADMIN") {
      if (account == "ADMIN" || account == "SUPER_ADMIN") return false;
      else return true;
    } else return false;
  };

  return userData ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title={userData.name}
          extra={[
            <Button
              key="3"
              className="themeBtn noBg"
              onClick={modalShow}
              // disabled={
              //   !userDetails.roles.user_management.edit ||
              //   userData.role_type === "Super Admin"
              // }
              disabled={
                userData.role_type === "Super Admin" ||
                userData.role_type === "ADMIN" ||
                !userDetails.roles.user_management.edit ||
                userDetails.email === userData.email
              }
            >
              <Iconmoon icon="delete" size={14} color="#EA655B" />
              Delete User
            </Button>,
            canResetPassword(userDetails?.role_type, userData?.role_type) ? (
              <Button key="2" className="themeBtn noBg" onClick={showDrawer}>
                <Iconmoon icon="relock" size={14} color="#EA655B" />
                Reset Password
              </Button>
            ) : (
              <></>
            ),
            <Link
              to={{
                pathname: "/organization-setting/user-management/edit-user",
                search: `?email=${userData.email}`,
                state: { email: userData.email },
              }}
            >
              <Button
                key="1"
                className="themeBtn"
                disabled={
                  userData.role_type === "Super Admin" ||
                  userData.role_type === "ADMIN" ||
                  !userDetails.roles.user_management.edit ||
                  userDetails.email === userData.email
                }
              >
                <Iconmoon icon="edit" size={14} color="#ffffff" />
                Edit User
              </Button>
            </Link>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Row gutter={[16, 16]} className="groupForm">
              <Col span={8}>
                <GroupTitle>
                  <h2>General Details</h2>
                  <p>Enter general details of the user</p>
                </GroupTitle>
              </Col>
              <Col span={16}>
                <Row className="centerAlign">
                  <Col span={12}>
                    <div className="boxFieldTitle">
                      <label>User Name</label>
                      <p>Your business will be identified using this name</p>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="boxFormType">
                      <Form.Item
                        name="Business Name"
                        rules={[{ required: true }]}
                        className=""
                      >
                        <Input
                          placeholder="Enter your name"
                          disabled
                          defaultValue={userData.name}
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row className="centerAlign">
                  <Col span={12}>
                    <div className="boxFieldTitle">
                      <label>Email Address</label>
                      <p>User can login using this email address</p>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="boxFormType">
                      <Form.Item
                        name="Business Owner"
                        rules={[{ type: "email" }]}
                        className=""
                      >
                        <Input
                          placeholder="Enter Email"
                          disabled
                          defaultValue={userData.email}
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row className="centerAlign">
                  <Col span={12}>
                    <div className="boxFieldTitle">
                      <label>Role Type</label>
                      <p>User will have selected role</p>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="boxFormType">
                      <Form.Item name="Role Type" rules={[{}]} className="">
                        <Input
                          placeholder="User Role"
                          disabled
                          defaultValue={userData.role_type}
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row className="centerAlign">
                  <Col span={12}>
                    <div className="boxFieldTitle">
                      <label>User Status</label>
                      <p>
                        User can access to Kaiznn only if it{"'"}s set to active
                      </p>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="boxFormType">
                      <Form.Item name="Status" rules={[{}]} className="">
                        <Input
                          placeholder="User Status"
                          disabled
                          defaultValue={userData.status}
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="groupForm"
              style={{ borderBottom: "0px" }}
            >
              <Col span={8}>
                <GroupTitle style={{ marginTop: "10px" }}>
                  <h2>Notifications</h2>
                  <p>This user will have access to selected notifications</p>
                </GroupTitle>
              </Col>
            </Row>
            {notificationData.map((notification) => (
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>{notification.name}</h2>
                    <p>{notification.text}</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  {notification.options.map((group) => (
                    <>
                      <Row
                        className="centerAlign titleVCenter paddingTB"
                        style={{ border: "none" }}
                      >
                        <Col span={12}>
                          <label style={{ marginLeft: "22px" }}>
                            {group.name}
                          </label>
                        </Col>
                        <Col span={12}>
                          <div
                            style={{
                              display: "flex",
                              gap: "50px",
                              marginLeft: "18px",
                            }}
                          >
                            <span>In App</span>
                            <span>Email</span>
                          </div>
                        </Col>
                      </Row>
                      {group.options.map((opt, optIndex) => (
                        <Row
                          className="centerAlign"
                          style={{
                            border: "none",
                            marginBlock: "0px",
                            paddingBlock: "0px",
                          }}
                          key={optIndex}
                        >
                          <Col span={12}>
                            <div
                              className="boxFieldTitle centerAlign"
                              style={{ paddingInlineStart: "25px" }}
                            >
                              <span>{opt}</span>
                            </div>
                          </Col>
                          <Col span={12}>
                            <Row>
                              <Col span={12}>
                                <div className="boxFormType reverseCheckbox">
                                  <div className="imageShowed">
                                    <label className="centerAlign">
                                      <span>
                                        {showAccessIcon(
                                          userData.notification_config[
                                            `${opt}_in_app`
                                              .toLowerCase()
                                              .replaceAll(" ", "_")
                                          ]
                                        )}
                                      </span>{" "}
                                    </label>
                                  </div>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType reverseCheckbox">
                                  <div className="imageShowed">
                                    <label className="centerAlign">
                                      <span>
                                        {showAccessIcon(
                                          userData.notification_config[
                                            `${opt}_email`
                                              .toLowerCase()
                                              .replaceAll(" ", "_")
                                          ]
                                        )}
                                      </span>{" "}
                                    </label>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      ))}
                    </>
                  ))}
                  {/* <Row className="centerAlign titleVCenter paddingTB">
                      <Col span={24}>
                        <Collapse
                          // onChange={onChangeCollpase}
                          expandIconPosition="right"
                          bordered={false}
                          style={{ backgroundColor: "white", width: "100%" }}
                        ></Collapse>
                      </Col>
                    </Row> */}
                </Col>
              </Row>
            ))}
          </div>
        </HaberForm>
      </DetailFields>
      <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Delete User?</span>
          <p>
            Once deleted the user can not be recovered. Are you sure you want to
            continue?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm(userData.id)}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
      <RightDrawerSidebar
        title="Reset password"
        subtitle=""
        visible={SideDrawer}
        extra={[<Button>OK</Button>]}
        onClose={onClose}
      >
        <RightDrawerContainer>
          <div className="titleWithText">
            <h5>Reset Password for {userData.name}</h5>
            <p>The user will be notified about the change</p>
          </div>
          <div className="resetPassForm removeStar">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                validateMessages={validateMessages}
                onFinish={(values) => {
                  onConfirmClick();
                }}
                onFinishFailed={(error) => {
                  console.log("Error passwords", error);
                }}
              >
                <Form.Item
                  label="New Password"
                  name="password"
                  rules={[
                    { required: true },
                    {
                      validator: () => {
                        if (
                          validLength &&
                          hasNumber &&
                          upperCase &&
                          lowerCase &&
                          specialChar
                        )
                          return Promise.resolve();
                        else return Promise.reject();
                      },
                    },
                  ]}
                  className="lockIcon firstPass dBlock"
                  // Prevent the password to be copied
                  onCopy={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                >
                  <Input.Password
                    placeholder="Enter your password"
                    onChange={setFirst}
                  />
                </Form.Item>

                <Form.Item
                  label="Confirm Password"
                  name="confirmpassword"
                  rules={[
                    { required: true },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value)
                          return Promise.resolve();
                        else return Promise.reject();
                      },
                    }),
                  ]}
                  className="lockIcon dBlock"
                >
                  <Input.Password
                    placeholder="Confirm password"
                    onChange={setSecond}
                  />
                </Form.Item>

                {/* Validations showing- START  */}
                <ul className="pwdStrength">
                  <li>
                    {validLength ? (
                      <span>
                        <img src={correctIcon} alt="correct" />
                      </span>
                    ) : (
                      <span>
                        <img src={wrongIcon} alt="wrong" />
                      </span>
                    )}{" "}
                    Atleast 8 characters long
                  </li>
                  <li>
                    {hasNumber ? (
                      <span>
                        <img src={correctIcon} alt="correct" />
                      </span>
                    ) : (
                      <span>
                        <img src={wrongIcon} alt="wrong" />
                      </span>
                    )}{" "}
                    One numeric charater
                  </li>
                  <li>
                    {upperCase ? (
                      <span>
                        <img src={correctIcon} alt="correct" />
                      </span>
                    ) : (
                      <span>
                        <img src={wrongIcon} alt="wrong" />
                      </span>
                    )}{" "}
                    One uppercase character
                  </li>
                  <li>
                    {lowerCase ? (
                      <span>
                        <img src={correctIcon} alt="correct" />
                      </span>
                    ) : (
                      <span>
                        <img src={wrongIcon} alt="wrong" />
                      </span>
                    )}{" "}
                    One lowercase character
                  </li>
                  <li>
                    {specialChar ? (
                      <span>
                        <img src={correctIcon} alt="correct" />
                      </span>
                    ) : (
                      <span>
                        <img src={wrongIcon} alt="wrong" />
                      </span>
                    )}{" "}
                    One special character{" "}
                  </li>
                  <li>
                    {match ? (
                      <span>
                        <img src={correctIcon} alt="correct" />
                      </span>
                    ) : (
                      <span>
                        <img src={wrongIcon} alt="wrong" />
                      </span>
                    )}{" "}
                    Password matching
                  </li>
                </ul>
                {/* Validations showing- STOP  */}

                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      className="themeBtn noBg"
                      disabled={
                        !(
                          validLength &&
                          hasNumber &&
                          upperCase &&
                          lowerCase &&
                          specialChar &&
                          match
                        )
                      }
                    >
                      <Iconmoon icon="addcircle" size={16} color="#EA655B" />{" "}
                      Confirm{" "}
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button className="themeBtn noBg" onClick={onClose}>
                      <Iconmoon icon="addcircle" size={16} color="#EA655B" />{" "}
                      Cancel{" "}
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </div>
        </RightDrawerContainer>
      </RightDrawerSidebar>
    </RightLayoutContainer>
  ) : null;
};

export default UserProfileData;
